import * as React from "react"
import { Router } from "react-static"
import Routes from "react-static-routes"
import "./styles"
import { ErrorBoundary } from "./components/ErrorBoundary"

export default () => (
  <ErrorBoundary>
    <Router>
      <Routes />
    </Router>
  </ErrorBoundary>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js